var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4854 17.288H62.2769V27.7115C62.2769 30.1212 63.3935 30.352 65.458 30.2966V31.2568C63.2203 31.3999 61.0738 31.0814 61.1877 27.7161V17.2926H58.4624V16.3324H61.1877V11.6884H62.2769V16.3324H65.4854V17.2926V17.288Z",
    fill: "#496F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6391 23.9354C68.5798 27.4484 70.4165 30.6428 74.0578 30.6428C76.8378 30.6428 78.8158 28.9579 79.3307 26.202H80.42C79.8457 29.6873 77.5534 31.603 74.0578 31.603C69.7556 31.603 67.4952 28.1778 67.5499 24.0554C67.4906 19.9608 69.6144 15.9816 74.0578 15.9816C78.5013 15.9816 80.739 19.67 80.5339 23.9354H68.6391ZM79.4447 22.9752C79.3854 19.8408 77.4394 16.9371 74.0578 16.9371C70.6762 16.9371 68.8715 20.0162 68.6391 22.9752H79.4447Z",
    fill: "#496F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0568 13.5119V10.5205H85.146V13.5119H84.0568ZM84.0568 31.2522V16.3278H85.146V31.2522H84.0568Z",
    fill: "#496F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.195 28.4916C100.195 29.3641 100.195 30.292 101.17 30.292C101.37 30.292 101.63 30.2643 101.972 30.2043V31.1322C101.657 31.1922 101.37 31.2476 101.083 31.2476C99.3651 31.2476 99.1053 30.2874 99.1053 29.0687V28.2839H99.0461C98.3579 30.0566 96.38 31.5938 93.5727 31.5938C90.7653 31.5938 88.6415 30.5182 88.6415 27.3837C88.6415 23.8985 91.6221 23.1737 94.0603 22.9706C98.9322 22.6244 99.1327 22.3012 99.1327 19.8638C99.1327 19.1945 98.3853 16.9325 95.0356 16.9325C92.3968 16.9325 90.6514 18.3266 90.5055 20.9117H89.4163C89.5576 17.6296 91.5674 15.9769 95.0356 15.9769C97.6151 15.9769 100.195 16.7894 100.195 19.8684V28.4916ZM99.1053 22.7721C98.244 23.76 95.8969 23.6446 93.7732 23.9354C91.1937 24.2262 89.7308 25.1541 89.7308 27.3884C89.7308 29.1887 91.0205 30.6382 93.6 30.6382C98.5585 30.6382 99.1053 26.3405 99.1053 25.5557V22.7675V22.7721Z",
    fill: "#496F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.01 31.2522V28.2609H107.473V31.2522H106.01Z",
    fill: "#A8C400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06 16.3278H114.149V19.5222H114.209C114.956 17.288 117.189 15.9816 119.482 15.9816C124.668 15.9816 124.727 20.1916 124.727 22.0197V31.2522H123.638V21.8165C123.638 20.2793 123.465 16.9371 119.454 16.9371C116.159 16.9371 114.149 19.5222 114.149 23.1783V31.2522H113.06V16.3278Z",
    fill: "#A8C400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 10.5205V31.2522H128.911V10.5205H130Z",
    fill: "#A8C400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3753 19.9654C11.3753 28.3855 17.0994 35.5222 25.0019 37.9688C32.9045 35.5222 38.6286 28.3855 38.6286 19.9654C38.6286 11.5453 32.9045 4.41315 25.0019 1.96191C17.0994 4.40854 11.3753 11.5453 11.3753 19.9654Z",
    fill: "url(#paint0_linear_7_2378)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.697 20.1269C12.697 26.2897 15.4177 31.7738 19.6424 35.2868C23.8672 31.7784 26.5879 26.2897 26.5879 20.1269C26.5879 13.9642 23.8672 8.48009 19.6424 4.9671C15.4177 8.47547 12.697 13.9642 12.697 20.1269Z",
    fill: "#739A00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6613 22.0889C20.2121 28.2608 19.1502 29.858 20.4718 34.5343C24.7923 31.1783 27.4811 26.0081 27.4811 20.1177C27.4811 14.2273 24.7877 9.0525 20.4673 5.69647C21.593 13.5395 22.5318 17.1079 21.6613 22.0842V22.0889Z",
    fill: "#496F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6424 1.84651C29.4682 1.84651 37.4619 9.92499 37.4619 19.85C37.4619 29.775 29.4682 37.8534 19.6424 37.8534C9.81665 37.8534 1.82296 29.775 1.82296 19.85C1.82296 9.92499 9.81665 1.84651 19.6424 1.84651ZM19.6424 0C8.79579 0 0 8.88632 0 19.85C0 30.8136 8.79579 39.6999 19.6424 39.6999C30.489 39.6999 39.2848 30.8136 39.2848 19.85C39.2848 8.88632 30.489 0 19.6424 0Z",
    fill: "#739A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0998 2.14656C40.9255 2.14656 48.9192 10.225 48.9192 20.15C48.3313 31.2799 40.7068 38.5966 31.0998 38.1535C21.274 38.1535 13.2803 30.075 13.2803 20.15C13.2803 10.225 21.274 2.14656 31.0998 2.14656ZM31.0998 0.300049C20.2531 0.300049 11.4573 9.18637 11.4573 20.15C11.4573 31.1137 20.2531 40 31.0998 40C41.9464 40 50.7422 31.1137 50.7422 20.15C50.7422 9.18637 41.9464 0.300049 31.0998 0.300049Z",
    fill: "#496F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_2378",
    x1: 25.4668,
    y1: 2.70052,
    x2: 24.5784,
    y2: 34.7922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#A7C4B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8C400"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b81813a3f318a7db5d001654acba4916.svg";
export { ForwardRef as ReactComponent };